import { z } from "zod";

/**
 * QuoteNodeSchema - Content Schema for Quote Node
 *
 * Quote nodes are block-level containers for quoted text.
 *
 * Nesting constraints (based on Lexical's isInline check):
 * - ✅ Supports: TextNode, StockNode, TagNode, LinkNode, LinebreakNode (inline nodes only)
 * - ❌ Does NOT support: ParagraphNode, ListNode, HeadingNode, QuoteNode (block nodes)
 */
export const QuoteNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("quote"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  children: z.array(z.any()), // Array of child nodes (text, stock, tag, link only)
}).strict();

export type QuoteNode = z.infer<typeof QuoteNodeSchema>;
